import type React from "react"
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner"

interface LoadingScreenProps {
  title: string
  description: string
  size?: "small" | "medium" | "large"
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ title, description, size = "large" }) => (
  <div className="loading-screen">
    <div className="loading-content">
      <LoadingSpinner size={size} />
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  </div>
)

export default LoadingScreen
